import React from 'react';
import Alert from 'react-bootstrap/Alert';
import Button from 'react-bootstrap/Button';

const ErrorAlert = ({ message, onRetry }) => (
  <Alert variant="danger" className="my-3">
    <p className="mb-0">{message}</p>
    {onRetry && (
      <Button variant="outline-danger" size="sm" className="mt-2" onClick={onRetry}>
        Intentar de nuevo
      </Button>
    )}
  </Alert>
);

export default ErrorAlert;
